var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 0.5H1.8C0.8076 0.5 0 1.27926 0 2.23684V3.87584C0 4.48547 0.2292 5.03953 0.6 5.46563V10.9211C0.6 11.0746 0.663214 11.2219 0.775736 11.3304C0.888258 11.439 1.04087 11.5 1.2 11.5H6C6.15913 11.5 6.31174 11.439 6.42426 11.3304C6.53679 11.2219 6.6 11.0746 6.6 10.9211V8.02632H9V10.9211C9 11.0746 9.06321 11.2219 9.17574 11.3304C9.28826 11.439 9.44087 11.5 9.6 11.5H10.8C10.9591 11.5 11.1117 11.439 11.2243 11.3304C11.3368 11.2219 11.4 11.0746 11.4 10.9211V5.46505C11.7708 5.03953 12 4.48547 12 3.87526V2.23684C12 1.27926 11.1924 0.5 10.2 0.5ZM10.8 2.23684V3.87584C10.8 4.53584 10.2906 5.09858 9.6654 5.13042L9.6 5.13158C8.9382 5.13158 8.4 4.61226 8.4 3.97368V1.65789H10.2C10.5312 1.65789 10.8 1.91784 10.8 2.23684ZM4.8 3.97368V1.65789H7.2V3.97368C7.2 4.61226 6.6618 5.13158 6 5.13158C5.3382 5.13158 4.8 4.61226 4.8 3.97368ZM1.2 2.23684C1.2 1.91784 1.4688 1.65789 1.8 1.65789H3.6V3.97368C3.6 4.61226 3.0618 5.13158 2.4 5.13158L2.3346 5.12984C1.7094 5.09858 1.2 4.53584 1.2 3.87584V2.23684ZM4.8 8.60526H2.4V6.86842H4.8V8.60526Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarketplace);
export default __webpack_public_path__ + "static/media/icon-marketplace.ef21f8a3dd07c9b206ca3b936d8c13d3.svg";
export { ForwardRef as ReactComponent };